<template>
  <v-dialog v-model="dialogUpload" max-width="400" persistent>
    <v-card class="upload-card" rounded="lg" elevation="8">
      <!-- Header -->
      <v-card-title class="primary white--text py-4">
        <span class="text-h6 font-weight-medium">{{ title }}</span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closePopup">
          <i class="fas fa-times"></i>
        </v-btn>
      </v-card-title>

      <!-- Content -->
      <v-card-text class="pa-6">
        <v-container>
          <!-- Drop Zone -->
          <v-sheet class="drop-zone pa-6 text-center" :class="{ 'drag-over': isDragging }" rounded outlined
            @dragover.prevent="dragover" @dragleave="dragleave" @drop.prevent="drop" @click="$refs.file.click()">
            <input type="file" multiple ref="file" accept=".xls, .xlsx" class="d-none" @input="onChange" />

            <i class="fas fa-cloud-upload-alt fa-2x mb-4" style="color: #bdbdbd;"></i>

            <div class="text-body-1">
              Kéo thả file Excel vào đây hoặc
              <span class="primary--text font-weight-medium pointer">nhấn để chọn</span>
            </div>

            <v-chip v-if="filelist.length" small color="primary" class="mt-3">
              {{ filelist.length }} file đã chọn
            </v-chip>
          </v-sheet>

          <!-- File List -->
          <v-list v-if="filelist.length" dense class="mt-4" max-height="150" style="overflow-y: auto">
            <v-list-item v-for="(file, index) in filelist" :key="file.name">
              <v-list-item-content>
                <v-list-item-title class="text-caption">
                  {{ file.name }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon small color="red" @click="remove(index)">
                  <i class="fas fa-trash-alt"></i>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-container>
      </v-card-text>

      <!-- Actions -->
      <v-card-actions class="pa-4">
        <a v-if="temp_file" :href="temp_file" target="_blank" class="text-decoration-none primary--text">
          Tải tệp mẫu
        </a>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="closePopup" class="px-4">
          Hủy
        </v-btn>
        <v-btn color="primary" depressed @click="importFile" :disabled="!filelist.length" class="px-4">
          Xác nhận
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from "lodash";

export default {
  name: "upload-file-popup",
  props: ["dialogUpload", "title", "temp_file"],
  data() {
    return {
      filelist: [],
      isDragging: false
    };
  },
  methods: {
    closePopup() {
      this.filelist = [];
      this.$emit("closePopup");
    },
    importFile() {
      this.$emit("importFile", this.filelist);
      this.filelist = [];
    },
    onChange() {
      this.filelist = [...this.$refs.file.files];
      this.$refs.file.value = null;
    },
    remove(index) {
      this.filelist.splice(index, 1);
    },
    dragover() {
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(event) {
      this.isDragging = false;
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange();
    }
  },
  mounted() {
    this.$store.dispatch("commons/getAllStores");
  }
};
</script>

<style scoped>
.upload-card {
  overflow: hidden;
}

.drop-zone {
  background-color: #f5f5f5;
  border: 2px dashed #bdbdbd;
  transition: all 0.3s ease;
  cursor: pointer;
}

.drop-zone.drag-over {
  background-color: #e8f5e9;
  border-color: #4caf50;
}

.drop-zone:hover {
  background-color: #eeeeee;
}

.pointer {
  text-decoration: underline;
  cursor: pointer;
}

.v-btn {
  text-transform: none;
  letter-spacing: 0.5px;
}
</style>